import { lazy } from 'react';

import type { TApplicationRoute } from '@modules/core/types';

import { FEE_RULES_ROUTE_PATHS } from './config';

export const FEE_RULES_ROUTES: TApplicationRoute[] = [
  {
    id: 'finance-fee-rules',
    path: FEE_RULES_ROUTE_PATHS.feeRules,
    component: lazy(() => import('./pages/fee-rules-page')),
    layout: 'default',
    permissions: { roles: [] },
    menu: {
      title: 'Fee Rules',
    },
  },
];
